import { render, staticRenderFns } from "./CoreInfo.vue?vue&type=template&id=22415544&scoped=true&"
import script from "./CoreInfo.vue?vue&type=script&lang=js&"
export * from "./CoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./CoreInfo.vue?vue&type=style&index=0&id=22415544&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22415544",
  null
  
)

export default component.exports